// SLAITraining.js
import React, { useState } from 'react';
import './SLAITraining.css';

const SLAITraining = () => {
    const [useRAG, setUseRAG] = useState(true);

    return (
        <div className="prompt-builder-page">
            {/* Import Scripts */}
            <div className="section import-scripts">
                <h2>Import Scripts</h2>
                <p className="section-subtitle">
                    Drag and drop your script files here or click to upload. Ensure that your scripts are in the correct format for seamless integration.
                </p>
                <div className="upload-area-container">
                    <div className="drop-zone">Drop files here or click to upload</div>
                    <div className="uploaded-list">
                        <div className="uploaded-item">Script1.js</div>
                        <div className="uploaded-item">Script2.js</div>
                        <div className="uploaded-item">Script3.js</div>
                    </div>
                </div>
            </div>

            {/* Import Calls */}
            <div className="section import-calls">
                <h2>Import Calls</h2>
                <p className="section-subtitle">
                    Upload your call logs or recordings here. Accepted formats include CSV, MP3, and WAV for efficient processing.
                </p>
                <div className="upload-area-container">
                    <div className="drop-zone">Drop files here or click to upload</div>
                    <div className="uploaded-list">
                        <div className="uploaded-item">Call_Log1.csv</div>
                        <div className="uploaded-item">Recording2.mp3</div>
                        <div className="uploaded-item">Call_Log3.csv</div>
                    </div>
                </div>
            </div>

            {/* Knowledge Base */}
            <div className="section knowledge-base">
                <h2>Knowledge Base</h2>
                <p className="section-subtitle">
                    Add your documents to the knowledge base for easy access and sharing. Supported formats include PDF, DOCX, and TXT.
                </p>

                {/* Upload buttons */}
                <div className="upload-buttons-row">
                    <button className="upload-btn">Upload File</button>
                    <button className="upload-btn">Upload URL</button>
                    <button className="upload-btn">Upload Text</button>
                </div>

                <div className="upload-area-container">
                    <div className="drop-zone">Drop files here or click to upload</div>
                    <div className="uploaded-list">
                        <div className="uploaded-item">Knowledge1.pdf</div>
                        <div className="uploaded-item">Guide2.docx</div>
                        <div className="uploaded-item">Notes3.txt</div>
                    </div>
                </div>

                {/* RAG Toggle */}
                <div className="rag-toggle-row">
                    <span className="rag-label">Use RAG</span>
                    <p className="rag-description">
                        Retrieval-Augmented Generation (RAG) Enable RAG to allow the SLAI agent to access relevant information
                        during answer generation, ensuring accurate and contextual responses.
                    </p>
                    <label className="rag-switch">
                        <input
                            type="checkbox"
                            checked={useRAG}
                            onChange={() => setUseRAG(!useRAG)}
                        />
                        <span className="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default SLAITraining;
